<template>
  <div>
    <add-kiosk-view
      v-if="$route.name === 'kiosk' || $route.name === 'add-kiosk' || $route.name === 'edit-kiosk'"
      :readonly="$route.name === 'kiosk'"
    />
  </div>
</template>

<script>
import AddKioskView from 'tenants/AddKioskView';

export default {
  components: { AddKioskView },
};
</script>



// WEBPACK FOOTER //
// src/components/kiosks/MainView.vue